// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2b723c7","239":"513be638","453":"b38d1e9e","732":"f5ec5d3a"}[chunkId] + ".chunk.js";
};